import { render, staticRenderFns } from "./ProductGallery.vue?vue&type=template&id=1244ae1b&scoped=true"
import script from "./ProductGallery.vue?vue&type=script&lang=js"
export * from "./ProductGallery.vue?vue&type=script&lang=js"
import style0 from "./ProductGallery.vue?vue&type=style&index=0&id=1244ae1b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1244ae1b",
  null
  
)

export default component.exports
import {QCarousel,QBtn,QIcon,QCarouselSlide,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCarousel,QBtn,QIcon,QCarouselSlide,QImg})
